import { Routes } from '@angular/router';
import { authGuard } from '../auth/auth.guard';
import { MatchesComponent } from './matches.component';

export const MATCH_ROUTES: Routes = [
  {
    path: 'matches/create',
    loadComponent: () => import('./create-match/create-match.component').then(m => m.CreateMatchComponent),
    canActivate: [authGuard]
  },
  {
    path: 'matches/:id',
    loadComponent: () => import('./match-details/match-details.component').then(m => m.MatchDetailsComponent),
    canActivate: [authGuard]
  },
  {
    path: 'matches',
    component: MatchesComponent,
    canActivate: [authGuard]
  }
];
